<template>
<div class="container mt-4">
    <div class="position-relative d-inline-block menu-item pt-2" v-for="(item,index) in cash.mainCategories" :key="item.id" @click="goPage(item.id)" >
        <div class="bg-light rounded shadow-sm" style="width: fit-content;margin-right: auto;margin-left: auto;">
            <img :src="'https://radap.ir/'+item.img_url" class="card-img-top rounded" >
        </div>
        <h5 class="card-title text-center my-2 bg-transparent" style="font-size: 13px;font-weight: 700;">{{ item.name }}</h5>
        <span class="position-absolute top-0  translate-middle badge rounded-pill bg-danger" style="font-size: 10px;padding-top: 2px;right: 65%" v-if="item.badge">
                {{item.badge}}
        </span>
    </div>
    <div class="position-relative d-inline-block menu-item pt-2 ">
        <router-link :to="{name:'Simcard',query:{mode:'charge'}}">
            <div class="bg-light rounded shadow-sm" style="width: fit-content;margin-right: auto;margin-left: auto;">
                <img src="https://radap.ir/imagesUploaded/category/1560366316.jpg" class="card-img-top rounded" >
            </div>
            <h5 class="card-title text-center my-2 bg-transparent text-dark" style="font-size: 13px;font-weight: 700;">شارژ و اینترنت</h5>
        </router-link>
    </div>
</div>
</template>
<script setup>
import { useCash } from '@/store/cash';
import { onMounted } from 'vue';
import {useRouter} from 'vue-router';
let router = useRouter()
const cash = useCash()
onMounted(() => {
	cash.getMainCategories()
})

function goPage(id){
	router.push({name:'Shops',params:{item:id}})
}
</script>

<style scoped>
img{
    width: 4rem;
    min-width: 4rem;
    max-width: 4rem;
    min-height: 4em;
    max-height: 4em;
}

.menu-item{
    width:25%; 
}
@media (max-width:290px) {
    .menu-item{
        width: 50%;
    }
}
</style>